import { render, staticRenderFns } from "./CreateReportPanel.vue?vue&type=template&id=3a580c86&scoped=true&"
import script from "./CreateReportPanel.vue?vue&type=script&lang=js&"
export * from "./CreateReportPanel.vue?vue&type=script&lang=js&"
import style0 from "./CreateReportPanel.vue?vue&type=style&index=0&id=3a580c86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a580c86",
  null
  
)

export default component.exports